<template>
    <div v-if="paymentMethods && paymentMethods.transfer" class="pt-2">
        <p>{{ $t('_checkout._payment.depositInstruction') }}:</p>

        <ul class="checkout-options">
            <li v-for="bank in banks">
                <input
                    :id="`bank-${bank.label}`"
                    v-model="selectedBank"
                    :value="bank"
                    class="cr-radio"
                    type="radio"
                />
                <label :for="`bank-${bank.label}`">
                    <span>{{ bank.label }}</span>
                </label>
            </li>
        </ul>
    </div>
</template>

<script>
    import CheckoutPaymentMethod from './CheckoutPaymentMethod';

    export default {
        extends: CheckoutPaymentMethod,

        name: 'CheckoutPaymentTransfer',

        props: ['cart', 'customer', 'paymentMethods'],

        data() {
            const banks = [
                { label: 'Caixa', module: 'transfcaixa' },
                { label: 'BB', module: 'transfbb' },
                { label: 'Bradesco', module: 'transfbradesco' },
                { label: 'Itaú', module: 'transfitau' },
            ];

            return {
                banks,
                selectedBank: banks[0],
                description: this.$t('_shop.bankDeposit'),
            };
        },

        methods: {
            submit(callback) {
                callback({ module: this.selectedBank.module, installments: 1 });
            },
        },
    };
</script>
